import type { RoutePath } from "./types";
import { interceptNavLinks, navigate } from "./router";
import { renderAbout } from "./pages/about";
import { renderArt } from "./pages/art";
import { renderGames } from "./pages/games";
import { renderHome } from "./pages/home";
import { renderMusic } from "./pages/music";

function navLink(path: RoutePath, label: string, current: RoutePath): string {
  const cls = current === path ? "active" : "";
  return `<a href="${path}" class="${cls}" data-nav="${path}">${label}</a>`;
}

export function renderShell(current: RoutePath): string {
  return `
    <header class="sanoi-header">
      <div class="sanoi-header-inner">
        <a href="/" class="sanoi-brand" data-nav="/">
          <span class="sanoi-brand-mark">尚诺艾</span>
          <span class="sanoi-brand-sub">SANOI</span>
        </a>
        <button
          type="button"
          class="sanoi-nav-toggle"
          aria-label="打开主导航"
          aria-expanded="false"
          aria-controls="sanoi-nav"
        >
          <span class="sanoi-nav-toggle-bar" aria-hidden="true"></span>
          <span class="sanoi-nav-toggle-bar" aria-hidden="true"></span>
          <span class="sanoi-nav-toggle-bar" aria-hidden="true"></span>
        </button>
        <nav id="sanoi-nav" class="sanoi-nav" aria-label="主导航">
          ${navLink("/", "首页", current)}
          ${navLink("/music", "名曲馆", current)}
          ${navLink("/art", "名画馆", current)}
          ${navLink("/games", "互动游戏", current)}
          ${navLink("/about", "关于", current)}
        </nav>
      </div>
    </header>
    <main class="sanoi-main" id="main-outlet"></main>
    <footer class="sanoi-footer">
      <div class="sanoi-footer-inner">
        <span>古典名曲 · 古典名画 · 策展式线上体验 · © 尚诺艾 SANOI</span>
      </div>
    </footer>
  `;
}

function pageContent(path: RoutePath): string {
  switch (path) {
    case "/music":
      return renderMusic();
    case "/art":
      return renderArt();
    case "/games":
      return renderGames();
    case "/about":
      return renderAbout();
    default:
      return renderHome();
  }
}

function wireMobileNav(root: HTMLElement): void {
  const header = root.querySelector<HTMLElement>(".sanoi-header");
  const toggle = root.querySelector<HTMLButtonElement>(".sanoi-nav-toggle");
  const nav = root.querySelector<HTMLElement>("#sanoi-nav");
  if (!header || !toggle || !nav) return;

  const close = () => {
    header.classList.remove("nav-open");
    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute("aria-label", "打开主导航");
    document.body.classList.remove("sanoi-nav-lock");
  };

  toggle.addEventListener("click", () => {
    const open = !header.classList.contains("nav-open");
    header.classList.toggle("nav-open", open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    toggle.setAttribute("aria-label", open ? "关闭主导航" : "打开主导航");
    document.body.classList.toggle("sanoi-nav-lock", open);
  });

  nav.querySelectorAll("a").forEach((a) => a.addEventListener("click", close));
  window.addEventListener(
    "resize",
    () => {
      if (window.matchMedia("(min-width: 768px)").matches) close();
    },
    { passive: true }
  );
}

export function mountShell(root: HTMLElement, path: RoutePath): void {
  root.innerHTML = renderShell(path);
  const outlet = root.querySelector("#main-outlet");
  if (outlet) outlet.innerHTML = pageContent(path);
  interceptNavLinks(root);
  wireMobileNav(root);

  root.querySelectorAll(".pillar-card[data-route]").forEach((el) => {
    el.addEventListener("click", () => {
      const r = el.getAttribute("data-route") as RoutePath | null;
      if (r) navigate(r);
    });
  });
}
